import React from 'react';
import { useHistory } from 'react-router-dom';
import { OTHER_ROUTES } from 'utils/routes';
import { INITIAL_BREADCRUMB, QUERY_PARAM_TO_TAB } from 'utils/types';
import BreadcrumbUI, { ItemType } from 'components/Breadcrumb/UI';

interface Props {
  onSelectedTabChange?: (selectedTab: string) => void;
}

const Breadcrumb: React.FC<Props> = ({ onSelectedTabChange }) => {
  const history = useHistory();

  const inferredFromPage = () => {
    let params = new URLSearchParams(window.location.search);
    let keysArray = [];
    params.forEach((_value, key) => {
      keysArray.push(key);
    });
    switch (keysArray[0]) {
      case 'account':
      case 'store':
      case 'stores_group':
        return 'Account';
      case 'item':
      case 'items_group':
        return 'Item';
      case 'campaign':
        return 'Campaign';
      default:
        return 'Account';
    }
  };

  const getFirstStep = () => {
    if (window.location.pathname === OTHER_ROUTES.DETAILS) return `${inferredFromPage()} Overview`;
    else return INITIAL_BREADCRUMB.get(window.location.pathname);
  };

  const navigateFromBreadcrumb = (stepSize: any, paramsKey: string) => {
    if (stepSize !== 0) {
      onSelectedTabChange && onSelectedTabChange(QUERY_PARAM_TO_TAB.get(paramsKey));
      history.go(stepSize);
    }
  };

  const getBreadcrumbItems = (breadcrumbs: Array<any>): Array<ItemType> => {
    const items: Array<ItemType> = [];
    // First item
    const firstItem = { label: getFirstStep(), onClick: undefined };
    if (breadcrumbs.length > 0) {
      firstItem.onClick = () => history.go(breadcrumbs.length * -1);
    }
    items.push(firstItem);
    // Add rest of items
    breadcrumbs.forEach((elem, i, arr) => {
      let paramsKey = elem.key.slice(0, -5);
      let stepSize = i - arr.length + 1;
      let item: ItemType;
      if (elem.value.includes('%20')) {
        item = { label: decodeURIComponent(elem.value), onClick: undefined };
      } else {
        item = { label: elem.value, onClick: undefined };
      }
      if (stepSize < 0) {
        if (paramsKey === '$campaign') {
          item.onClick = () => history.go(stepSize);
        } else {
          item.onClick = () => navigateFromBreadcrumb(stepSize, paramsKey);
        }
      }
      items.push(item);
    });
    return items;
  };

  let params = new URLSearchParams(window.location.search);
  let breadcrumbs = [];
  params.forEach((value, key) => {
    if (key.includes('name')) breadcrumbs.push({ value, key });
  });

  return <BreadcrumbUI items={getBreadcrumbItems(breadcrumbs)} />;
};

export default Breadcrumb;
